export default {
      id: "arrow-left-usage",
      viewBox: "0 0 5 7",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }